import { FC } from "react";
import { NotificationDto } from "@/modules/notification-center/dtos";
import { NotificationTemplateFactory } from "./notification-templates/notification-card.factory";

const NotificationCardRenderer: FC<{ notification: NotificationDto }> = ({
  notification,
}) => {
  const TemplateComponent = NotificationTemplateFactory(notification);
  return <TemplateComponent notification={notification} />;
};

export default NotificationCardRenderer;
